import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {
    Button, CircularProgress,
    Grid,
    Switch,
    TextField
} from "@mui/material";
import {CompareArrows, Search} from "@mui/icons-material";
import Body from "../global/Body";
import {useDispatch, useSelector} from "react-redux";
import {selectRequestState, setFare, setItem, setStep} from '../../store/request/stateSlice'
import withReducer from "../../store/withReducer";
import reducer from "../../store/request";
import {memo, useState} from "react";
import AltLocation from "../global/AltLocation";
import Api from "../../inc/Api";
import Alert from "../../inc/Alert";

function Step1() {

    const state = useSelector(selectRequestState);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    function loadFare() {
        setLoading(true);
        Api.post(`/widgets/${state.item.id_widget}/fare`, state.item, rsp => {
            setLoading(false);
            if (rsp.ok) {

                dispatch(setFare(rsp));
                dispatch(setStep('2'));

                if (state.item.product) {
                    dispatch(setItem({
                        product: rsp.products.find(o => o.id === state.item.product.id && !o.error),
                    }));
                }

            } else {
                Alert.error(rsp.msg);
            }
        });
    }

    return (
        <Body title="Elige la dirección y la fecha" onSubmit={loadFare}>
            <Box sx={{
                backgroundColor  : 'primary.main',
                px          : 2,
                pt          : 1,
                borderRadius: '14px 14px 0 0',
                width       : 220,
                height      : 46,
                position    : 'absolute',
                top         : -46,
                left        : 0,
            }} display="flex">
                <Typography variant="h6" color="white" flexGrow={1}>
                    {state.item.type_request == 'with_return' ? 'Ida y vuelta' : 'Solo ida'}
                </Typography>
                <Switch
                    color="default"
                    checked={state.item.type_request == 'with_return'}
                    onChange={e => {
                        dispatch(setItem({type_request: e.target.checked ? 'with_return' : 'no_return'}));
                    }}/>
            </Box>

            <Grid container spacing={3}>

                <Grid xs={12} md={5} item>

                    <AltLocation
                        label="Desde"
                        value={state.item.org}
                        onChange={point => dispatch(setItem({org: point}))}
                        locations={state.data.item.address_restriction === '1'
                            ? null
                            : state.data.item.address_restriction === '2'
                                ? state.data.locations
                                : state.item.from_airport
                                    ? state.data.locations
                                    : null}
                        autoFocus/>

                </Grid>

                <Grid xs={3} md={2} item>

                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: 'white',
                        }}
                        onClick={() => {
                            dispatch(setItem({
                                from_airport: !state.item.from_airport,
                                org         : {...state.item.dst},
                                dst         : {...state.item.org},
                            }));
                        }}
                        fullWidth>
                        <CompareArrows fontSize="large" color="primary"/>
                    </Button>

                </Grid>

                <Grid xs={9} md={5} item>

                    <AltLocation
                        label="Hasta"
                        value={state.item.dst}
                        onChange={point => dispatch(setItem({dst: point}))}
                        locations={state.data.item.address_restriction === '1'
                            ? null
                            : state.data.item.address_restriction === '2'
                                ? state.data.locations
                                : state.item.from_airport
                                    ? null
                                    : state.data.locations}
                    />

                </Grid>

                <Grid xs={7} md={3} item>

                    <TextField
                        label="Fecha de salida desde el Aeropuerto"
                        value={state.item.start_part_date}
                        onChange={e => dispatch(setItem({
                            start_part_date: e.target.value,
                            date_start     : state.item.start_part_time
                                ? `${e.target.value} ${state.item.start_part_time}`
                                : ''
                        }))}
                        InputLabelProps={{shrink: true}}
                        InputProps={{
                            sx: {
                                '& input[type="date"]::-webkit-calendar-picker-indicator': {
                                    filter   : 'invert(34%) sepia(95%) saturate(7491%) hue-rotate(210deg) brightness(50%) contrast(101%)',
                                    marginTop: -2,
                                    fontSize : 22,
                                },
                            },
                        }}
                        type="date"/>

                </Grid>

                <Grid xs={5} md={2} item>

                    <TextField
                        label="Hora"
                        value={state.item.start_part_time}
                        onChange={e => dispatch(setItem({
                            start_part_time: e.target.value,
                            date_start     : state.item.start_part_date
                                ? `${state.item.start_part_date} ${e.target.value}`
                                : ''
                        }))}
                        InputLabelProps={{shrink: true}}
                        InputProps={{
                            sx: {
                                '& input[type="time"]::-webkit-calendar-picker-indicator': {
                                    filter   : 'invert(34%) sepia(95%) saturate(7491%) hue-rotate(210deg) brightness(50%) contrast(101%)',
                                    marginTop: -2,
                                    fontSize : 22,
                                },
                            },
                        }}
                        type="time"/>

                </Grid>

                <Grid md={2} item display={{xs: 'none', md: 'block'}}/>

                {state.item.type_request == 'with_return' && (
                    <Grid xs={7} md={3} item>

                        <TextField
                            label="Fecha de regreso"
                            value={state.item.return_part_date}
                            onChange={e => dispatch(setItem({
                                return_part_date: e.target.value,
                                date_return     : state.item.return_part_time
                                    ? `${e.target.value} ${state.item.return_part_time}`
                                    : ''
                            }))}
                            InputLabelProps={{shrink: true}}
                            InputProps={{
                                sx: {
                                    '& input[type="date"]::-webkit-calendar-picker-indicator': {
                                        filter   : 'invert(34%) sepia(95%) saturate(7491%) hue-rotate(210deg) brightness(50%) contrast(101%)',
                                        marginTop: -2,
                                        fontSize : 22,
                                    },
                                },
                            }}
                            type="date"/>

                    </Grid>
                )}

                {state.item.type_request == 'with_return' && (
                    <Grid xs={5} md={2} item>

                        <TextField
                            label="Hora"
                            value={state.item.return_part_time}
                            onChange={e => dispatch(setItem({
                                return_part_time: e.target.value,
                                date_return     : state.item.return_part_date
                                    ? `${state.item.return_part_date} ${e.target.value}`
                                    : ''
                            }))}
                            InputLabelProps={{shrink: true}}
                            InputProps={{
                                sx: {
                                    '& input[type="time"]::-webkit-calendar-picker-indicator': {
                                        filter   : 'invert(34%) sepia(95%) saturate(7491%) hue-rotate(210deg) brightness(50%) contrast(101%)',
                                        marginTop: -2,
                                        fontSize : 22,
                                    },
                                },
                            }}
                            type="time"/>

                    </Grid>
                )}

                <Grid xs={12} item>
                    <Typography color="white">
                        Agenda tu viaje con 3 horas de anticipación.
                    </Typography>
                </Grid>

                <Grid xs={6} md={9} item/>

                <Grid xs={6} md={3} item>

                    <Button
                        variant="contained"
                        endIcon={!loading && <Search/>}
                        disabled={!(state.item.org.lat != 0 && state.item.org.address && state.item.dst.lat != 0
                            && state.item.dst.address && state.item.date_start
                            && (state.item.type_request == 'no_return' || state.item.date_return)) || loading}
                        type="submit"
                        fullWidth>
                        {loading ? <CircularProgress color="inherit" size="24px"/> : 'Buscar'}
                    </Button>

                </Grid>

            </Grid>
        </Body>
    );
}

export default withReducer('request', reducer)(memo(Step1));